import React from "react";

import web from "../src/images/4.jpg";
import app from "../src/images/2.jpg";
import software from "../src/images/5.jpg";
import marketing from "../src/images/6.jpg";
import ai from "../src/images/3.jpg";
import hardware from "../src/images/8.jpg";

const Sdata = [
{
    imgsrc: web,
    title: "Web Development"
},
{
    imgsrc: app,
    title: "App Development"
},
{
    imgsrc: software,
    title: "Software Development"
},
{
    imgsrc: marketing,
    title: "Digital Marketing"
},
{
    imgsrc: ai,
    title: "Artificial Intelligence"
},
{
    imgsrc: hardware,
    title: "Computer Hardwares"
},
]

export default Sdata;